<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <div class="row">
      <div class="col-sm-3">
        <h4 qid="measures-page-title" class="mb-1">
          {{ $t('maintenance.measures.title') }}
        </h4>
        <div>
          <span v-if="getGuide('measures_list')">
            <GuideButton :guide="getGuide('measures_list')"></GuideButton>
          </span>
        </div>
      </div>
      <div class="col-sm-9 text-right">
        <!-- <button
            class="btn btn-secondary-dark float-right"
            @click="filterOpened = !filterOpened"
            qid="measures-create-button"
        >
          <font-awesome-icon icon="filter"/>
        </button> -->
        <span v-if="isGranted(permissions.MEASURE_CREATE)"
              class="btn btn-success float-right"
              qid="create-m-button"
              @click="showCreateMModal()"
        >
          <font-awesome-icon icon="plus-circle"/> {{ $t('maintenance.measures.create_button') }}
        </span>
        <span class="btn btn-secondary float-right"
              qid="users-merge-button"
              v-if="isGranted(permissions.MEASURE_CREATE)"
              @click="showImportModal()"
        >
          {{ $t('maintenance.measures.import_button') }}
        </span>
        <b-form-input
          type="text"
          v-model="filters.keywordValue"
          class="float-right mw-300 mr-3 search-bar"
          qid="search-p-input"
          v-on:input="handleSearch()"
          :placeholder="$t('maintenance.measures.search_placeholder')"
        ></b-form-input>
      </div>
    </div>

    <div class="row" :class="{'table-with-filters': filterOpened}">
      <div class="col-sm-10 table-container">
        <div class="row tree-filter-row">
          <div class="col-sm-2 tree-filter-col">
            <div class="card filter-tree-view-container">
              <div class="card-body p-0 tree-filter-col">
                <MeasureSideFilter
                    v-if="SideFilterRenderComponent"
                    :selectedCategory="selectedCategory"
                    :updateList="updateChildList"
                    @updateSelected="updateSelectedFilter"
                ></MeasureSideFilter>
              </div>
            </div>
          </div>

          <div class="col-sm-10 tree-result-col">
            <MeasureTopBar
              :selectedCategory="selectedCategory"
              @forceSideFilterRenderComponent="forceSideFilterRenderComponent"
            ></MeasureTopBar>

            <div class="tree-result-main">

              <table class="table table-responsive-md table-list-secondary">
                <thead>
                  <tr>
                    <th scope="col"
                        class="cursor-pointer"
                        @click="selectSort('name')"
                        qid="sort-p-name"
                    >
                      {{ $t('maintenance.measures.table.name') }}
                      <span class="ml-2">
                        <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'name'"/>
                        <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'name'"/>
                        <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'name'"/>
                      </span>
                    </th>
                    <th width="130" class="text-right"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(object, index) in tableItems" :key="'table-row-' + index" :id="'table-row-' + index">
                    <b-popover
                        :target="'table-row-' + index"
                        boundary="viewport"
                        triggers="hover"
                        placement="topleft"
                        :delay="{ show: 500, hide: 0 }"
                    >
                      <div v-if="object.measure_category" class="mt-2">
                        <span class="text-bold">
                          {{ $t('maintenance.measures.table.category') }}:
                        </span>
                        <br>
                        <span v-if="object.measure_category"
                              class="text-normal ml-2"
                        >
                          <font-awesome-icon icon="toolbox"/>
                            {{ object.measure_category.name }}
                        </span>
                        <br>
                      </div>

                      <div v-if="object.description" class="mt-2">
                        <span class="text-bold">
                          {{ $t('maintenance.measures.create.description_label') }}:
                        </span>
                        <br>
                        {{ object.description | truncate(200)}}
                        <br>
                      </div>

                      <div v-if="object.value" class="mt-2">
                        <span class="text-bold">
                          {{ $t('maintenance.measures.table.value') }}:
                        </span>
                        <br>
                        <span v-if="object.value"
                              class="text-normal ml-2"
                        >
                          {{ object.value }}
                        </span>
                        <br>
                      </div>

                      <div v-if="object.measure_category && object.measure_category.scope && object.measure_category.scope.length">
                        <span class="text-bold">
                          {{ $t('maintenance.measures.table.scope') }}:
                        </span>
                        <br>
                        <span v-for="(scope, index) in object.measure_category.scope" :key="'m_scope' + index">
                          <span v-if="scope == 'activity'" class="text-normal ml-2">
                            <font-awesome-icon icon="cubes"/>
                              {{ $t('projects.scope.activity') }}
                          </span>

                          <span v-if="scope == 'system'" class="text-normal ml-2">
                            <font-awesome-icon icon="desktop"/>
                              {{ $t('projects.scope.system') }}
                          </span>

                          <span v-if="scope == 'third_party'" class="text-normal ml-2">
                            <font-awesome-icon icon="exchange-alt"/>
                              {{ $t('projects.scope.third_party') }}
                          </span>
                          <span v-if="scope == 'assessment'" class="text-normal ml-2">
                            <font-awesome-icon icon="crosshairs"/>
                            {{ $t('projects.scope.assessment') }}
                          </span>
                        </span>
                        <br>
                      </div>
                    </b-popover>

                    <td>
                      <router-link
                          :to="{ name: 'maintenance.measures.view', params: { slug: object.slug }}"
                          qid="p-view-page-link"
                      >
                        {{ object.name }}
                      </router-link>
                    </td>

                    <td align="right">
                      <span v-if="isGranted([permissions.MEASURE_EDIT, permissions.MEASURE_EDIT_OWN], object.created_by) && (!getClient.parent || (getClient.parent && object.partition))"
                            class="btn btn-edit"
                            qid="edit-p-modal"
                            @click="showEditMModal(object)"
                      >
                        <font-awesome-icon icon="pen"/>
                      </span>
                      <span v-if="isGranted([permissions.MEASURE_DELETE, permissions.MEASURE_DELETE_OWN], object.created_by) && (!getClient.parent || (getClient.parent && object.partition))"
                            class="btn btn-delete"
                            qid="delete-p-modal"
                            @click="showConfirmDeleteModal(object)"
                      >
                        <font-awesome-icon icon="trash-alt"/>
                      </span>
                    </td>
                  </tr>

                  <tr v-if="!loading && !tableItems.length" qid="no-results-row" class="text-center">
                    <td colspan="10">
                      <h5 class="mt-3">
                        {{ $t('system.no_results') }}
                      </h5>
                    </td>
                  </tr>

                  <div class="mt-5" v-if="loading">
                    <div class="swing-container">
                      <div class="swing">
                        <div class="swing-l"></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div class="swing-r"></div>
                      </div>
                    </div>
                  </div>
                </tbody>
              </table>

              <div class="mt-3 pagination row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="float-left">
                      <span class="text-muted pagination-counter">
                        {{ $t('pagination.entries_per_page') }}:
                      </span>
                    </div>
                    <div class="float-left">
                      <multiselect
                          v-model="perPage"
                          :options="perPageOptions"
                          track-by="value"
                          :select-label="$t('system.dropdown_select_label')"
                          :selected-label="$t('system.dropdown_selected_label')"
                          :deselect-label="$t('system.dropdown_deselect_label')"
                          label="value"
                          qid="create-org-form-measure"
                          @select="perPageChanged"
                          :placeholder="selectedPerPage"
                          @remove="perPageRemoved"
                      ></multiselect>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <b-pagination
                      class="float-right"
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="selectedPerPage"
                      aria-controls="my-table"
                      @change="pageChanged"
                      limit="1"
                  >
                    <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
                    <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
                    <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
                    <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
                    <div slot="ellipsis-text">
                      <b-spinner small type="grow"></b-spinner>
                      <b-spinner small type="grow"></b-spinner>
                      <b-spinner small type="grow"></b-spinner>
                    </div>
                    <span class="text-muted" slot="page" slot-scope="{ page, active }">
                      <span v-if="active">{{getPerPage}}</span>
                    </span>
                  </b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- Create measure -->
    <b-modal ref="create-measure" @hide="hideCreateMModal" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateMModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-m-title">
            {{ $t('maintenance.measures.create.title') }}
          </h5>
          <div class="row mt-2 pt-4 pb-1" v-if="getGuide('create_measure')">
            <div class="col-sm-12">
              <b-form-group>
                <div class="">
                  <label qid="create-p-users-label">
                    <font-awesome-icon icon="info-circle"/>
                    {{ $t('system.help_center_label') }}
                  </label>
                  <div v-if="wpGuide && wpGuide.id" class="guide-content-container">
                    <p v-if="!showFullGuideDescription" v-html="wpGuide.excerpt.rendered"></p>
                    <p v-if="showFullGuideDescription" v-html="wpGuide.content.rendered"></p>

                    <div class="text-center mt-3" @click="showFullGuideDescription=!showFullGuideDescription">
                      <span class="cursor-pointer" v-if="!showFullGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_more') }}
                        </span>
                        <font-awesome-icon icon="chevron-down"/>
                      </span>
                      <span class="cursor-pointer" v-if="showFullGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_less') }}
                        </span>
                        <font-awesome-icon icon="chevron-up"/>
                      </span>
                    </div>
                  </div>
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-m-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="createMFormSubmit" qid="create-m-form">
        <b-form-group>
          <label qid="create-m-name-label">
            {{ $t('maintenance.measures.create.name_label') }}<span class="mandatory"> *</span>
          </label>
          <b-form-input
            qid="create-m-form-name"
            type="text"
            v-model="pForm.name"
            required
            :maxLength="255"
            :placeholder="$t('maintenance.measures.create.name_placeholder')"
          ></b-form-input>
        </b-form-group>
        <b-form-group>
          <label qid="create-m-category-label">
            {{ $t('maintenance.measures.create.category_label') }}<span class="mandatory"> *</span>
          </label>
          <div class="multiselect-row">
            <multiselect
                v-model="selectedMeasureCategory"
                :options="categoryItems"
                :placeholder="$t('maintenance.measures.create.category_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @search-change="loadCategories"
                track-by="slug"
                qid="create-ac-form-ac"
            ></multiselect>
            <b-button
                class="btn btn-secondary float-right"
                @click="showCreateMCModal()"
                qid="create-mc-button"
                v-if="isGranted(permissions.MEASURE_CREATE)"
                v-b-tooltip.hover
                :title="$t('maintenance.measure_categories.create_button')"
            >
              <font-awesome-icon icon="plus-circle"/>
            </b-button>
          </div>
        </b-form-group>
        <b-form-group>
          <label qid="create-m-description-label">
            {{ $t('maintenance.measures.create.description_label') }}
          </label>
          <b-form-textarea
            qid="create-m-form-description"
            v-model="pForm.description"
            rows="6"
            max-rows="6"
            :placeholder="$t('maintenance.measures.create.description_placeholder')"
          ></b-form-textarea>
        </b-form-group>


        <b-form-group>
          <label qid="create-m-implementation-status-label">
            {{ $t('maintenance.measures.create.value_label') }}<span class="mandatory"> *</span>
          </label>
          <multiselect
              v-model="pForm.value"
              :options="valueItems"
              :placeholder="$t('maintenance.measures.create.value_placeholder')"
              label="name"
              @select="valueSelected"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              qid="create-p-form-implementation-status"
          ></multiselect>
        </b-form-group>
        <b-form-group v-if="pForm.value && pForm.value.value == 'number'">
          <label qid="create-p-implementation-status-label">
            {{ $t('maintenance.measures.create.currency_label') }}<span class="mandatory"> *</span>
          </label>
          <multiselect
              v-model="pForm.currency"
              :options="currencyItems"
              :placeholder="$t('maintenance.measures.create.currency_placeholder')"
              label="name"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              qid="create-p-form-implementation-status"
          ></multiselect>
        </b-form-group>

        <b-form-group v-if="pForm.value && pForm.value.value == 'dropdown'">
          <label qid="create-p-pg-label">
            {{ $t('maintenance.measures.values.dropdown_type') }}<span class="mandatory"> *</span>
          </label>
          <multiselect
              v-model="responseType"
              :options="responseTypes"
              :placeholder="$t('maintenance.questions.create.type_placeholder')"
              label="name"
              @select="handleType"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              qid="create-p-form-pg"
          ></multiselect>
        </b-form-group>

        <b-form-group v-if="responseType && responseType.value == 'Select' && pForm.value && pForm.value.value == 'dropdown'">
          <label qid="create-p-link-label">
            {{ $t('maintenance.questions.create.options_label') }}<span class="mandatory"> *</span>
          </label>
          <p v-for="(option, index) in selectedOptions" :key="'m_response_' + index">
            <span class="float-right text-muted cursor-pointer"
                  @click="removeOptionItem(index, option)"
                  qid="create-m-link-remove"
            >
              <font-awesome-icon icon="trash-alt" />
            </span>
            <span>{{ option }}</span>
          </p>
          <div class="input-group">
            <b-form-input
              qid="create-m-form-link"
              type="text"
              v-if="showInput"
              v-on:keydown.enter="handleOption"
              v-model="inputOption"
              :placeholder="$t('maintenance.questions.create.options_placeholder')"
            ></b-form-input>
            <div class="input-group-append" v-if="showInput">
              <span class="input-group-text cursor-pointer"
                    id="inputGroup"
                    @click="handleOption"
                    qid="handle-link-save"
              >
                {{ $t('system.save') }}
              </span>
            </div>
          </div>
          <span class="btn btn-link cursor-pointer float-right"
                @click="showInput = true"
                v-if="!showInput"
                qid="create-m-add-link"
          >
            <font-awesome-icon icon="plus"/> {{ $t('maintenance.questions.create.add_option_label') }}
          </span>
        </b-form-group>
      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideCreateMModal"
                            qid="create-m-cancel-button"
                  >
                    {{ $t('maintenance.measures.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            @click="createMFormSubmit"
                            :disabled="buttonDisabled"
                            qid="create-m-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.measures.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <!-- Delete Measure confirm modal template -->
    <b-modal ref="delete-measure" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideConfirmDeleteModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="update-m-title">
            {{ $t('maintenance.measures.delete.title') }}
          </h5>
        </div>
      </template>
      <div class="mb-2 mt-3" style="font-size:18px;">
        <div>
          {{ $t('maintenance.measures.delete.description') }}
          <span class="text-bold">
            {{ itemToDelete.name }}
          </span>
        </div>
        <div class="mt-2">
          {{ $t('maintenance.measures.delete.are_you_sure') }}
        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class="mt-3"
                            variant="secondary"
                            @click="hideConfirmDeleteModal"
                            qid="delete-p-cancel-button"
                  >
                    {{ $t('maintenance.measures.delete.cancel') }}
                  </b-button>
                  <b-button @click="confirmDeleteM(itemToDelete)"
                            class="mt-3 ml-3"
                            variant="danger"
                            qid="delete-p-submit-button"
                            v-if="isGranted([permissions.MEASURE_DELETE, permissions.MEASURE_DELETE_OWN], itemToDelete.created_by) && (!getClient.parent || (getClient.parent && itemToDelete.partition))"
                  >
                    {{ $t('maintenance.measures.delete.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

    </b-modal>


    <!-- Edit Measure modal template -->
    <b-modal ref="edit-measure" @hide="hideEditMModal" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditMModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="update-m-title">
            {{ $t('maintenance.measures.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-m-error"
      >
        {{ error }}
      </b-alert>

      <b-form qid="edit-m-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-m-name-label">
              {{ $t('maintenance.measures.create.name_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-input
              qid="edit-m-form-name"
              type="text"
              v-model="pForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.measures.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-m-category-label">
              {{ $t('maintenance.measures.create.category_label') }}<span class="mandatory"> *</span>
            </label>
            <div class="multiselect-row">
              <multiselect
                  v-model="selectedMeasureCategory"
                  :options="categoryItems"
                  :placeholder="$t('maintenance.measures.create.category_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  @search-change="loadCategories"
                  track-by="slug"
                  qid="edit-m-form-category"
              ></multiselect>
              <b-button
                  class="btn btn-secondary float-right"
                  @click="showCreateMCModal()"
                  qid="create-mc-button"
                  v-if="isGranted(permissions.MEASURE_CREATE)"
                  v-b-tooltip.hover
                  :title="$t('maintenance.measure_categories.create_button')"
              >
                <font-awesome-icon icon="plus-circle"/>
              </b-button>
            </div>
          </b-form-group>
          <b-form-group>
            <label qid="edit-m-description-label">
              {{ $t('maintenance.measures.create.description_label') }}
            </label>
            <b-form-textarea
              qid="edit-m-form-description"
              v-model="pForm.description"
              rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.measures.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <label qid="create-p-implementation-status-label">
              {{ $t('maintenance.measures.create.value_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="pForm.value"
                :options="valueItems"
                :placeholder="$t('maintenance.measures.create.value_placeholder')"
                label="name"
                @select="valueSelected"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-implementation-status"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="pForm.value && pForm.value.value == 'number'">
            <label qid="create-p-implementation-status-label">
              {{ $t('maintenance.measures.create.currency_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="pForm.currency"
                :options="currencyItems"
                :placeholder="$t('maintenance.measures.create.currency_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-implementation-status"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="pForm.value && pForm.value.value == 'dropdown'">
            <label qid="create-p-pg-label">
              {{ $t('maintenance.measures.values.dropdown_type') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="responseType"
                :options="responseTypes"
                :placeholder="$t('maintenance.questions.create.type_placeholder')"
                label="name"
                @select="handleType"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-pg"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="responseType && responseType.value == 'Select' && pForm.value && pForm.value.value == 'dropdown'">
            <label qid="create-p-link-label">
              {{ $t('maintenance.questions.create.options_label') }}
              <span class="text-red">*</span>
            </label>
            <p v-for="(option, index) in selectedOptions">
              <span class="float-right text-muted cursor-pointer"
                    @click="removeOptionItem(index, option)"
                    qid="create-p-link-remove"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
              <span>{{ option }}</span>
            </p>
            <div class="input-group">
              <b-form-input
                qid="create-p-form-link"
                type="text"
                v-if="showInput"
                v-on:keydown.enter="handleOption"
                v-model="inputOption"
                :placeholder="$t('maintenance.questions.create.options_placeholder')"
              ></b-form-input>
              <div class="input-group-append" v-if="showInput">
                <span class="input-group-text cursor-pointer"
                      id="inputGroup"
                      @click="handleOption"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
            <span class="btn btn-link cursor-pointer float-right"
                  @click="showInput = true"
                  v-if="!showInput"
                  qid="create-p-add-link"
            >
              <font-awesome-icon icon="plus"/> {{ $t('maintenance.questions.create.add_option_label') }}
            </span>
          </b-form-group>
        </div>
      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideEditMModal"
                            qid="edit-m-cancel-button"
                  >
                    {{ $t('maintenance.measures.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            @click="editMFormSubmit"
                            :disabled="buttonDisabled"
                            qid="edit-m-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.measures.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <!-- Create measure category -->
    <b-modal ref="create-category" @hide="hideCreateMCModal" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateMCModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-mc-title">
            {{ $t('maintenance.measure_categories.create.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-mc-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="createMCFormSubmit" qid="create-mc-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-mc-name-label">
              {{ $t('maintenance.measure_categories.create.name_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-input
              qid="create-mc-form-name"
              type="text"
              v-model="MCForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.measure_categories.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-p-description-label">
              {{ $t('maintenance.measures.create.description_label') }}
            </label>
            <b-form-textarea
              qid="create-p-form-description"
              v-model="MCForm.description"
              rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.measures.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <label qid="create-mc-implementation-status-label">
              {{ $t('maintenance.measure_categories.create.scope_label') }}<span class="mandatory"> *</span>
            </label>
            <multiselect
                v-model="selectedScopes"
                :options="scopes"
                :multiple="true"
                track-by="value"
                :taggable="true"
                :placeholder="$t('maintenance.measure_categories.create.scope_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-mc-form-implementation-status"
            ></multiselect>
          </b-form-group>
        </div>
      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideCreateMCModal"
                            qid="create-mc-cancel-button"
                  >
                    {{ $t('maintenance.measures.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            @click="createMCFormSubmit"
                            :disabled="buttonDisabled"
                            qid="create-mc-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.measure_categories.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <!-- Import measures modal -->
    <b-modal ref="import-modal" @hide="hideImportModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideImportModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="update-user-title">
            {{ $t('maintenance.measures.import_button') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-user-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="importFormSubmit" qid="edit-user-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-user-upn-email-label">
              {{ $t('maintenance.measures.client_label') }}
            </label>
            <multiselect
                v-model="selectedClient"
                :options="clients"
                :multiple="false"
                track-by="slug"
                :placeholder="$t('maintenance.measures.client_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @select="clientSelected"
                qid="create-p-users-select"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedClient && selectedClient.id">
            <label qid="create-user-upn-email-label">
              {{ $t('maintenance.measures.partition_label') }}
            </label>
            <multiselect
                v-model="selectedPartition"
                :options="partitions"
                :multiple="false"
                track-by="slug"
                :placeholder="$t('maintenance.measures.partition_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @search-change="loadPartitions"
                qid="create-p-users-select"
            ></multiselect>
          </b-form-group>
        </div>
        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideImportModal"
                            qid="edit-user-cancel-button"
                  >
                    {{ $t('administration.users.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="edit-user-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.users.merge_users_submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>

  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import Avatar from '@/components/Avatar.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';
  import MeasureSideFilter from '@/components/measures/MeasureSideFilter.vue';
  import MeasureTopBar from '@/components/measures/MeasureTopBar.vue';

  export default {
    name: 'Measures',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('maintenance.title'),
            to: '/maintenance'
          },
          {
            text: this.$t('maintenance.measures.title'),
            active: true
          }
        ],
        tableItems: [],

        // Pagination
        perPageOptions: [
          { name: '10', value: '10' },
          { name: '20', value: '20' },
          { name: '50', value: '50' },
          { name: '100', value: '100' }
        ],
        perPage: '',
        selectedPerPage: "10",
        currentPage: 1,
        totalRows: 0,

        partitions: [],
        clients: [],
        selectedPartition: [],
        selectedClient: [],

        itemToDelete: {},
        pForm: {
          name: '',
          description: '',
          measure_category_id: '',
          value: [],
          currency: [],
          client:'',
          links: []
        },
        error: '',
        selectedSort: '',
        selectedDirection: '',
        filterOpened: false,
        keywordValue: '',
        filters: {
          category: '',
          keywordValue: ''
        },
        SideFilterRenderComponent: true,
        // TopBarRenderComponent: true,
        categoryItems: [],
        categoryInput: '',
        valueItems: [
          { name: this.$t('maintenance.measures.values.none'), value: 'none' },
          { name: this.$t('maintenance.measures.values.date'), value: 'date' },
          { name: this.$t('maintenance.measures.values.number'), value: 'number' },
          { name: this.$t('maintenance.measures.values.dropdown'), value: 'dropdown' }
        ],
        value: [],
        currencyItems: [
          {name: 'None', value: 'None'},
          {name: 'DKK', value: 'DKK'},
          {name: 'EUR', value: 'EUR'},
          {name: 'GBP', value: 'GBP'},
          {name: 'USD', value: 'USD'}
        ],
        currency: [],
        responseTypes: [
          { name: this.$t('maintenance.questions.type.yes/no'), value: 'Yes/No' },
          { name: this.$t('maintenance.questions.type.select'), value: 'Select' }
        ],
        yesNoOptions: [
          'Yes',
          'No'
        ],
        responseType: [],
        selectedOptions: [],
        inputOption: '',
        positiveAnswers: [],
        negativeAnswers: [],
        allAnswers: [],
        allAnswersCopy: [],
        showInput: true,
        loading: true,
        buttonDisabled: false,
        myGuides: [],
        wpGuide: {},
        showFullGuideDescription: false,
        selectedFilter: {},
        selectedFilterName: '',
        selectedCategory: {},
        selectedMeasureCategory: [],
        MCForm: {
          name: '',
          description: '',
          scope: []
        },
        scopes: [
          { name: this.$t('projects.scope.activity'), value: 'activity' },
          { name: this.$t('projects.scope.system'), value: 'system' },
          { name: this.$t('projects.scope.third_party'), value: 'third_party' },
          { name: this.$t('projects.scope.assessment'), value: 'assessment' },
        ],
        selectedScopes: [],
        updateChildList: false
      }
    },
    components: {
      Avatar,
      GuideButton,
      MeasureSideFilter,
      MeasureTopBar,
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getClient() {
        return this.$store.state.client
      },
      getFilters() {
        return this.$store.state.activeFilters
      },
      getStorePerPage() {
        return this.$store.state.perPage
      },
      getWordpressLink() {
        return this.$store.state.wordpressLink
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if(selectedTo > selectedOf){
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
      },
      getClients() {
        let clients = [];
        if (this.$store.state.user.clients) {
          for (var i = 0; i < this.$store.state.user.clients.length; i++) {
            if (!this.$store.state.user.clients[i].parent){
              clients.push(this.$store.state.user.clients[i]);
            }
          }
          if (clients && clients.length) {
            clients.sort(function(a, b) {
              var nameA = a.name.toUpperCase(); // ignore upper and lowercase
              var nameB = b.name.toUpperCase(); // ignore upper and lowercase
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              // names must be equal
              return 0;
            });
          }
        }
        return clients
      },
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadContent();
        this.loadCategories();
      },
      selectedOptions: function (value) {
        let self = this
        this.allAnswers = value
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        _.forEach(this.positiveAnswers, function (answer) {
          self.handleAvailableAnswers(answer)
        })
        _.forEach(this.negativeAnswers, function (answer) {
          self.handleAvailableAnswers(answer)
        })
      }
    },
    methods: {
      debounceInput: _.debounce(function() {
        this.loadContent()
      }, 400),
      handleSearch() {
        this.selectedCategory = null;
        this.filters.category = ''
        this.debounceInput()
      },
      updateSelectedFilter(item) {
        if (!item) {
          this.filters.category = {}
          this.selectedFilterName = ''
        }else{
          this.filters.category = item
          this.selectedFilterName = item.name
        }

        this.selectedCategory = this.filters.category;
        this.debounceInput()
      },
      clientSelected() {
        let self = this
        setTimeout(function(){
          self.loadPartitions()
        }, 300);
      },
      showImportModal(object) {
        let self = this;
        this.error = '';
        this.selectedClient = []
        this.selectedPartition = []
        this.buttonDisabled = false;
        this.loadClients()

        this.$refs['import-modal'].show()
      },
      hideImportModal() {
        this.$refs['import-modal'].hide()
      },
      loadPartitions() {
        let self = this;
        piincHttp.get('partitions', { params: {
          client: self.selectedClient && self.selectedClient.id ? self.selectedClient.slug : undefined,
          per_page: 0,
          sort: 'name',
          order: 'asc',
          manage_measures: 1,
          mine: 1
        }}).then(function(response) {
          self.partitions = [];
          _.forEach(response.data.items, function (item) {
            if (item.id != self.getClient.id){
              self.partitions.push(item);
            }
          })
        }, function() {});
      },
      loadClients() {
        let self = this;
        // Call api/me for logged in user details
        piincHttp.get('users/me', { params: {
          manage_measures: 1,
        }}).then(function(response) {
          self.clients = []
          _.forEach(response.data.clients, function (item) {
            if (!item.parent && item.id != self.getClient.id){
              self.clients.push(item);
            }
          })
        }, function() {});
      },
      importFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        if (evt) {
          evt.preventDefault();
        }
        this.updateChildList = false;

        if ((this.selectedClient && this.selectedClient.id) || (this.selectedPartition && this.selectedPartition.id)) {
          piincHttp.post('measures/import', {
            client: this.getClient.slug,
            from_client: this.selectedPartition && this.selectedPartition.slug ? this.selectedPartition.slug : this.selectedClient.slug,
          }).then(function(response) {
            self.$toastr('success', self.$t('maintenance.measures.import_success'))
            self.buttonDisabled = false;
            self.hideImportModal()
            self.loadContent();
            self.updateChildList = true;
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.buttonDisabled = false;
          this.error = self.$t('maintenance.measures.import_error')
        }
      },
      forceSideFilterRenderComponent(object) {
        // store selected category provided from the top bar component
        this.selectedCategory = object
        this.loadCategories()
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Maintenance' && object.enabled
        });
        return existingGuide
      },
      valueSelected(value) {
        if (value.value != 'dropdown') {
          this.selectedOptions = []
          this.responseType = []
        }
      },
      handleType(value) {
        this.positiveAnswers = []
        this.negativeAnswers = []
        if (value && value.value == 'Select') {
          this.allAnswers = this.selectedOptions
          this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        } else {
          this.allAnswers = this.yesNoOptions
          this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        }
      },
      handleOption(evt) {
        evt.preventDefault();
        // If there's a link in input, add it to links array
        if (this.inputOption !== '') {
          this.selectedOptions.push(this.inputOption)
          // Reset link input form
          this.inputOption = ''
        }
        this.showInput = false;
      },
      removeOptionItem(index, item) {
        let positiveIndex = _.findIndex(this.positiveAnswers, function(answer) { return answer == item })
        let negativeIndex = _.findIndex(this.negativeAnswers, function(answer) { return answer == item })

        this.selectedOptions.splice(index, 1);

        if (!this.selectedOptions.length) {
          this.showInput = true;
        }

        if (positiveIndex != -1) {
          this.positiveAnswers.splice(positiveIndex, 1)
        }
        if (negativeIndex != -1) {
          this.negativeAnswers.splice(negativeIndex, 1)
        }
      },
      handleAvailableAnswers(answer) {
        let index = _.findIndex(this.allAnswersCopy, function(item) { return answer == item })
        if (index != -1) {
          this.allAnswersCopy.splice(index, 1)
        }
      },
      expandAvailableAnswers(answer) {
        let index = _.findIndex(this.allAnswersCopy, function(item) { return answer == item })
        if (index == -1) {
          this.allAnswersCopy.push(answer)
        }
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Maintenance',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
            piincHttp.get(self.getWordpressLink + self.myGuides[0].external_id).then(function(response) {
              self.wpGuide = response.data
            }, function() {});
          }
        }, function() {});
      },
      setFilterCategory(item) {
        this.filters.category = item
        this.selectedFilterName = item.name
        this.debounceInput()
      },
      resetFilters() {
        this.filters.category = '',
        this.debounceInput()
      },
      handleCategoryInput(input) {
        this.categoryInput = input;
      },
      selectSort(sort) {
        // If old and new sort are same, switch just direction
        if (sort === this.selectedSort) {
          this.selectedDirection = this.selectedDirection === 'desc' ? 'asc' : 'desc';
        } else {
          // If different sort, set sort and set direction to default
          this.selectedDirection = 'desc'
          this.selectedSort = sort;
        }
        this.loadContent();
      },
      loadContent(page, perPage) {

        if (this.getStorePerPage) {
          this.selectedPerPage = this.getStorePerPage;
        }

        // If page is not defined, set page to default 1
        let pageNumber = page ? page : 1;
        let perPageNumber = perPage ? perPage : this.selectedPerPage;
        let self = this;

        if (
          this.filters.keywordValue !== '' ||
          (this.filters.category && this.filters.category.value)
        ) {
          this.filtersOpened = true
        }

        piincHttp.get('measures', { params:
          {
            page: pageNumber,
            per_page: perPageNumber,
            sort: this.selectedSort !== '' ? this.selectedSort : undefined,
            order: this.selectedDirection !== '' ? this.selectedDirection : undefined,
            keyword: this.filters.keywordValue !== '' ? this.filters.keywordValue : undefined,
            measure_category: this.filters.category ? this.filters.category.id : undefined,
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.loading = false;
          self.tableItems = response.data.items;
          // Set number of total items
          self.totalRows = response.data.total_count;
        }, function() {});
      },
      pageChanged(page) {
        this.loadContent(page)
      },
      perPageChanged(perPage) {
        let self = this;
        // Load content when page changed listener is triggered
        this.loadContent(1, perPage.value)
        self.selectedPerPage = perPage.value
        this.$store.commit('storePerPage', this.selectedPerPage);
      },
      perPageRemoved() {
        let self = this;
        // Load content when page changed listener is triggered
        self.selectedPerPage = self.perPageOptions[0].value
        this.loadContent(1, self.selectedPerPage)
      },
      showConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-measure'].show()
      },
      hideConfirmDeleteModal() {
        this.itemToDelete = {}
        this.$refs['delete-measure'].hide()
      },
      // Create measure methods
      showCreateMModal() {
        this.pForm.name = ''
        this.pForm.scope = []
        this.pForm.links = []
        this.pForm.value = []
        this.pForm.currency = []
        this.pForm.description = ''
        this.selectedScopes = []
        this.selectedFiles = []
        this.responseType = []
        this.selectedOptions = []
        this.inputOption = ''
        this.positiveAnswers = []
        this.allAnswers = []
        this.allAnswersCopy = []
        this.showInput = true
        this.currency = []
        this.selectedMeasureCategory = []
        this.loadCategories();
        this.error = ''
        this.$refs['create-measure'].show()
      },
      hideCreateMModal() {
        this.pForm.name = ''
        this.pForm.scope = []
        this.$refs['create-measure'].hide()
      },
      createMFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();
        this.updateChildList = false;
        this.pForm.client = this.getClient.slug;

        if (this.selectedMeasureCategory && this.selectedMeasureCategory.id) {
          this.pForm.measure_category_id = this.selectedMeasureCategory.id
        } else {
          this.pForm.measure_category_id = ''
        }

        if (this.responseType && this.responseType.value) {
          this.pForm.type = this.responseType.value
        }

        if (this.selectedOptions && this.selectedOptions.length) {
          this.pForm.type_options = JSON.stringify(this.selectedOptions)
        } else {
          this.pForm.type_options = '[]'
        }

        if (this.positiveAnswers && this.positiveAnswers.length) {
          this.pForm.type_positive_response = JSON.stringify(this.positiveAnswers)
        } else {
          this.pForm.type_positive_response = '[]'
        }

        if (
          (this.selectedMeasureCategory && this.selectedMeasureCategory.id) &&
          (this.pForm.name && this.pForm.name.length) &&
          (this.pForm.value && this.pForm.value.value) &&
          (
            (this.pForm.value.value == 'number' && this.pForm.currency && this.pForm.currency.value) ||
            ((this.pForm.value.value == 'dropdown' && this.responseType && this.responseType.value && ((this.responseType && this.responseType.value == 'Yes/No') || (this.responseType && this.responseType.value == 'Select' && this.selectedOptions && this.selectedOptions.length))) || (this.pForm.value.value == 'number' && this.pForm.currency && this.pForm.currency.value)) ||
            this.pForm.value.value == 'date' || this.pForm.value.value == 'none'
          )
        ){

          this.pForm.value = this.pForm.value ? this.pForm.value.value : '';
          this.pForm.currency = this.pForm.currency ? this.pForm.currency.value : '';

          piincHttp.post('measures/', this.pForm).then(function(response) {
            self.hideCreateMModal();
            self.loadContent(self.currentPage);
            self.updateChildList = true;
            self.buttonDisabled = false;
            self.$toastr('success', self.$t('maintenance.measures.create.success'))
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = ''
          this.buttonDisabled = false;

          if (this.pForm.name == '') {
            this.error +=  ' ' + this.$t('maintenance.incidents.incident_categories.create.name_error')
          }
          if (!this.selectedMeasureCategory || !this.selectedMeasureCategory.id) {
            this.error +=  ' ' + this.$t('system.category_error_message')
          }
          if (!this.pForm.value || (this.pForm.value && !this.pForm.value.value)) {
            this.error +=  ' ' + this.$t('system.value_error_message')
          }
          if ((this.pForm.value && this.pForm.value.value == 'dropdown') && this.responseType && !this.responseType.value) {
            this.error +=  ' ' + this.$t('system.response_type_error_message')
          }
          if ((this.pForm.value && this.pForm.value.value == 'number') && this.pForm.currency && !this.pForm.currency.value) {
            this.error +=  ' ' + this.$t('system.currency_error_message')
          }
          if ((this.responseType && this.responseType.value == 'Select') && this.selectedOptions && !this.selectedOptions.length) {
            this.error +=  ' ' + this.$t('system.selected_options_error_message')
          }
        }
      },
      showEditMModal(object) {
        let self = this;
        this.error = ''
        this.loadCategories();

        // Preselect category on edit modal
        this.selectedMeasureCategory = {}
        if (object.measure_category) {
          _.find(this.categoryItems, function(item) {
            if (item.id == object.measure_category.id) {
              self.selectedMeasureCategory = item;
            }
          });
        }

        this.pForm.value = []
        if (object.value) {
          this.pForm.value = _.find(this.valueItems, function(item) {
            return item.value === object.value;
          });
        }

        this.pForm.currency = []
        if (object.currency) {
          this.pForm.currency = _.find(this.currencyItems, function(item) {
            return item.value === object.currency;
          });
        }

        this.responseType = []
        if (object.type) {
          this.responseType = _.find(this.responseTypes, function(item) {
            return item.value === object.type;
          });

          if (object.type == 'Select') {
            this.allAnswers = this.selectedOptions
            this.allAnswersCopy = _.cloneDeep(this.allAnswers);
          } else {
            this.allAnswers = this.yesNoOptions
            this.allAnswersCopy = _.cloneDeep(this.allAnswers);
          }
        }

        this.positiveAnswers = []
        if (object.type_positive_response) {
          let array = JSON.parse(object.type_positive_response)
          this.positiveAnswers.push(...array)
        }

        if (object.type == 'Select') {
          this.selectedOptions = []
          if (object.type_options) {
            let array = JSON.parse(object.type_options)
            this.selectedOptions.push(...array)
          }
        }

        this.pForm.slug = object.slug;
        this.pForm.name = object.name;
        this.pForm.description = object.description;
        this.$refs['edit-measure'].show()
      },
      hideEditMModal() {
        this.error = ''
        this.categoryInput = ''
        this.selectedOptions = []
        this.inputOption = ''
        this.positiveAnswers = []
        this.allAnswers = []
        this.showInput = true
        this.responseType = []
        this.$refs['edit-measure'].hide()
      },

      // Create Measure category
      showCreateMCModal() {
        this.MCForm.name = ''
        this.MCForm.description = ''
        this.MCForm.scope = []
        this.selectedScopes = []
        this.error = ''
        this.$refs['create-category'].show()
      },
      hideCreateMCModal() {
        this.MCForm.name = ''
        this.MCForm.description = ''
        this.MCForm.scope = []
        this.error = ''
        this.$refs['create-category'].hide()
      },
      createMCFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();
        let scopes = []

        // Append list of types
        if (this.selectedScopes && this.selectedScopes.length) {
          for (var i = 0; i < this.selectedScopes.length; i++) {
            scopes.push(this.selectedScopes[i].value)
          }
        }

        this.MCForm.client = this.getClient.slug;
        this.MCForm.scope = scopes

        if (this.MCForm.scope.length && this.MCForm.name && this.MCForm.name.length) {
          piincHttp.post('measure-categories', this.MCForm).then(function(response) {
            self.hideCreateMCModal();
            self.buttonDisabled = false;
            // Reload the list of categories in the dropdown and provide newly created one to the function
            self.loadCategories(response.data);
            self.$toastr('success', self.$t('maintenance.measure_categories.create.success'))
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.buttonDisabled = false;
          this.error = ''
          if (this.MCForm.name == '') {
            this.error +=  ' ' + this.$t('maintenance.incidents.incident_categories.create.name_error')
          }
          if (this.selectedScopes && !this.selectedScopes.length) {
            this.error +=  ' ' + this.$t('system.scope_error_message')
          }
        }
      },
      loadCategories(selectedObject) {
        let self = this;
        piincHttp.get('measure-categories', { params:
          {
            per_page: 100,
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.categoryItems = response.data.items

          // If selected category is provided to this function, preselect it in dropdown
          if (selectedObject && selectedObject.id) {
            self.selectedMeasureCategory = selectedObject
          }

          if (self.categoryItems && !self.categoryItems.length) {
            self.categoryItems.push({category: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      editMFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();
        this.updateChildList = false;
        this.pForm.client = this.getClient.slug;

        if (this.selectedMeasureCategory && this.selectedMeasureCategory.id) {
          this.pForm.measure_category_id = this.selectedMeasureCategory.id
        } else {
          this.pForm.measure_category_id = ''
        }

        if (this.responseType && this.responseType.value) {
          this.pForm.type = this.responseType.value
        }

        if (this.selectedOptions && this.selectedOptions.length) {
          this.pForm.type_options = JSON.stringify(this.selectedOptions)
        } else {
          this.pForm.type_options = '[]'
        }

        if (this.positiveAnswers && this.positiveAnswers.length) {
          this.pForm.type_positive_response = JSON.stringify(this.positiveAnswers)
        } else {
          this.pForm.type_positive_response = '[]'
        }

        if (
          (this.selectedMeasureCategory && this.selectedMeasureCategory.id) &&
          (this.pForm.name && this.pForm.name.length) &&
          (this.pForm.value && this.pForm.value.value) &&
          (
            (this.pForm.value.value == 'number' && this.pForm.currency && this.pForm.currency.value) ||
            ((this.pForm.value.value == 'dropdown' && this.responseType && this.responseType.value && ((this.responseType && this.responseType.value == 'Yes/No') || (this.responseType && this.responseType.value == 'Select' && this.selectedOptions && this.selectedOptions.length))) || (this.pForm.value.value == 'number' && this.pForm.currency && this.pForm.currency.value)) ||
            this.pForm.value.value == 'date' || this.pForm.value.value == 'none'
          )
        ){

          this.pForm.value = this.pForm.value ? this.pForm.value.value : '';
          this.pForm.currency = this.pForm.currency ? this.pForm.currency.value : '';

          piincHttp.put('measures/' + this.pForm.slug, this.pForm).then(function(response) {
            self.hideEditMModal();
            self.loadContent(self.currentPage);
            self.buttonDisabled = false;
            self.updateChildList = true;
            self.$toastr('success', self.$t('maintenance.measures.update.success'))
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = ''
          this.buttonDisabled = false;

          if (this.pForm.name == '') {
            this.error +=  ' ' + this.$t('maintenance.incidents.incident_categories.create.name_error')
          }
          if (!this.selectedMeasureCategory || !this.selectedMeasureCategory.id) {
            this.error +=  ' ' + this.$t('system.category_error_message')
          }
          if (!this.pForm.value || (this.pForm.value && !this.pForm.value.value)) {
            this.error +=  ' ' + this.$t('system.value_error_message')
          }
          if ((this.pForm.value && this.pForm.value.value == 'dropdown') && this.responseType && !this.responseType.value) {
            this.error +=  ' ' + this.$t('system.response_type_error_message')
          }
          if ((this.pForm.value && this.pForm.value.value == 'number') && this.pForm.currency && !this.pForm.currency.value) {
            this.error +=  ' ' + this.$t('system.currency_error_message')
          }
          if ((this.responseType && this.responseType.value == 'Select') && this.selectedOptions && !this.selectedOptions.length) {
            this.error +=  ' ' + this.$t('system.selected_options_error_message')
          }
        }
      },
      confirmDeleteM(object) {
        let self = this;
        piincHttp.delete('measures/' + object.slug).then(function(response) {
          self.hideConfirmDeleteModal();
          self.loadContent(self.currentPage);
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('maintenance.measures.delete.success'))
        }, function() {});
      }
    },
    beforeRouteLeave(to, from, next) {
      let object = {
        type: 'measures',
        filters: this.filters
      }
      this.$store.commit('storeActiveFilters', object);
      this.$store.commit('storePerPage', this.selectedPerPage);
      next()
    },
    created () {
      if (this.getClient && this.getClient.slug) {
        if (this.getFilters.measures) {
          this.filters = this.getFilters.measures
          this.filters.category = ''
        }
        this.loadContent();
        this.loadCategories();
      }
      this.loadGuides('measures_list');
      this.loadGuides('create_measure');
    }
  }
</script>
